import { HeroEmailCapture } from '../components/marketing/HeroEmailCapture';
import { MarketingSiteLayout } from '../components/marketing/MarketingSiteLayout';
import { ShareBand } from '../components/marketing/ShareBand';
import { BEACONS, VOICE_PROMPTS } from '../prompts/prompts.generated';
import './promptPages.css';

/** /prompts — every beacon and voice prompt, static, one anchor per prompt. */
export function PromptsArchivePage() {
  return (
    <MarketingSiteLayout>
      <article className="prompt-page">
        <header className="prompt-hero prompt-hero--archive">
          <p className="prompt-kicker">The Kynward prompts</p>
          <h1 className="prompt-h1 prompt-h1--archive">Questions to ask someone new</h1>
          <p className="prompt-lead">
            Every beacon Kynward asks, and every voice prompt. They were written to be answered by a
            person rather than a profile: each hands over a situation, and the answer is what you
            did with it. Steal them for a dinner, a first date, a long drive, or a group chat that
            has gone quiet.
          </p>
          <p className="prompt-p">
            <a className="prompt-link" href="/prompt">
              Today’s prompt →
            </a>
          </p>
        </header>

        <section className="prompt-section" aria-labelledby="archive-beacons">
          <h2 id="archive-beacons" className="prompt-h2">
            The beacons
          </h2>
          <p className="prompt-p">Members answer six of these on their profile.</p>
          <ol className="prompt-list">
            {BEACONS.map((b) => (
              <li key={b.key} id={b.key} className="prompt-item">
                <h3 className="prompt-item__q">{b.question}</h3>
                <p className="prompt-item__hint">{b.hint}</p>
              </li>
            ))}
          </ol>
        </section>

        <section className="prompt-section" aria-labelledby="archive-voice">
          <h2 id="archive-voice" className="prompt-h2">
            Say it out loud
          </h2>
          <p className="prompt-p">
            Voice prompts: eighteen seconds, one take. Answered aloud on the profile, because a
            voice carries what text can’t.
          </p>
          <ol className="prompt-list">
            {VOICE_PROMPTS.map((v) => (
              <li key={v.key} id={v.key} className="prompt-item">
                <h3 className="prompt-item__q">{v.question}</h3>
              </li>
            ))}
          </ol>
        </section>

        <section className="prompt-section prompt-section--capture" aria-label="Join the waitlist">
          <p className="prompt-p">Want a Circle to ask you these instead?</p>
          <HeroEmailCapture source="prompts-archive" inputId="prompts-waitlist-email" />
        </section>

        <ShareBand />
      </article>
    </MarketingSiteLayout>
  );
}
